import { Text } from 'suomifi-ui-components'
import { LeftAndRightBlock } from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetOrderSummary/AetSummaryPriceInfo.sc'

interface RowProps {
  leftContent: string
  rightContent: string
  bold?: boolean
}

const PriceInfoRow: React.FC<RowProps> = ({
  leftContent,
  rightContent,
  bold,
}) => {
  const textVariant = bold ? 'bold' : undefined
  return (
    <LeftAndRightBlock>
      <Text variant={textVariant}>{leftContent}</Text>
      <Text variant={textVariant}>{rightContent}</Text>
    </LeftAndRightBlock>
  )
}

export default PriceInfoRow
